import React from 'react';
import useTitle from 'react-use/lib/useTitle';
import { OverviewFragmentLayout } from 'app/fragments/overview-fragment/layout';
import { OverviewStatItemProps } from 'app/fragments/overview-fragment/common/OverviewStatItem';

interface OverviewFragmentProps {
  subText: string;
  wikiLink?: string;
  pageTitle: string;
  pageParam: string;
  detailBaseFilter: string;
  statData: OverviewStatItemProps[];
  lineData: any;
  type: string;
}

const OverviewFragment = (props: OverviewFragmentProps) => {
  useTitle(`${document.title} activities`);
  return (
    <OverviewFragmentLayout
      title={props.pageTitle}
      subText={props.subText}
      wikiLink={props.wikiLink}
      lineData={props.lineData.vizData}
      lineCount={props.lineData.count}
      statData={props.statData}
      detailBaseFilter={props.detailBaseFilter}
      pageParam={props.pageParam}
      type={props.type}
    />
  );
};

export default OverviewFragment;
